import { env } from './constants'

interface Auth0Config {
  clientId: string
  domain: string
  audience?: string
  cacheLocation?: 'memory' | 'localstorage'
  useRefreshTokens?: boolean
}

const validateAuth0Config = () => {
  if (!env.CLIENT_ID) {
    throw new Error('Auth0 CLIENT_ID environment variable is required')
  }
  if (!env.DOMAIN) {
    throw new Error('Auth0 DOMAIN environment variable is required')
  }
}

// Validate configuration on initialization
validateAuth0Config()

const auth0Config: Auth0Config = {
  clientId: env.CLIENT_ID,
  domain: env.DOMAIN,
  cacheLocation: 'localstorage',
  useRefreshTokens: true,
}

export default auth0Config
